export default "__VITE_ASSET__BksL8tDU__"